<template>
  <path
    d="M15.38 8.50022L8.61998 8.50022L12 5.12022L15.38 8.50022ZM12.71 3.71022C12.32 3.32022 11.69 3.32022 11.3 3.71022L6.70998 8.30022C6.07998 8.92022 6.51998 10.0002 7.40998 10.0002L16.59 10.0002C17.48 10.0002 17.93 8.92022 17.3 8.29022L12.71 3.71022ZM16.59 14.0002L7.41998 14.0002C6.52998 14.0002 6.07998 15.0802 6.70998 15.7102L11.3 20.3002C11.69 20.6902 12.32 20.6902 12.71 20.3002L17.3 15.7102C17.92 15.0802 17.48 14.0002 16.59 14.0002Z"
  />
</template>
